import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  bg?: 'cream' | 'cream-dark' | 'plum' | 'blush' | 'gold-tint';
  noPadding?: boolean;
}
export function Section({
  children,
  className = '',
  id,
  bg = 'cream',
  noPadding = false
}: SectionProps) {
  const bgColors = {
    cream: 'bg-cream',
    'cream-dark': 'bg-cream-dark',
    plum: 'bg-plum text-cream',
    blush: 'bg-blush',
    'gold-tint': 'bg-[#F5EEDC]'
  };
  return <section id={id} className={`${bgColors[bg]} ${noPadding ? '' : 'py-12 md:py-32'} ${className}`} data-id="element-277">
      <div className="max-w-6xl mx-auto px-5 md:px-12" data-id="element-278">{children}</div>
    </section>;
}
export function FadeIn({
  children,
  delay = 0,
  className = ''
}: {
  children: React.ReactNode;
  delay?: number;
  className?: string;
}) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.7,
    delay,
    ease: [0.21, 0.47, 0.32, 0.98]
  }} className={className} data-id="element-279">
      {children}
    </motion.div>;
}